import { Injectable, inject } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs';
import { of } from 'rxjs';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as featureFlagActions from './feature-flag.actions';
import * as authActions from '../auth-store/auth.actions';

import { FeatureFlagDataService } from '../../services/feature-flag-data.service';

@Injectable()
export class FeatureFlagEffects {
  private actions$ = inject(Actions);
  private featureFlagService = inject(FeatureFlagDataService);

  /**
   * Load feature flags after successful login.
   */
  loadOnLogin$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.loginSuccess),
      map(() => featureFlagActions.loadFeatureFlags()),
    );
  });

  /**
   * Fetch resolved flags from the API.
   */
  loadFeatureFlags$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(featureFlagActions.loadFeatureFlags),
      mergeMap(() =>
        this.featureFlagService.getResolvedFlags().pipe(
          map(flags => featureFlagActions.loadFeatureFlagsSuccess({ flags })),
          catchError(error =>
            of(
              featureFlagActions.loadFeatureFlagsFailure({
                error: error.message || 'Failed to load feature flags',
              }),
            ),
          ),
        ),
      ),
    );
  });

  /**
   * Clear feature flags on logout.
   */
  clearOnLogout$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(authActions.logOut),
      map(() => featureFlagActions.clearFeatureFlags()),
    );
  });
}
